const isEmpty = <T extends object>(obj?: T): boolean => !!obj && Object.keys(obj).length === 0;

export const openBlankWindow = <T extends Record<string, string | number | boolean>>(url: string, params?: T): void => {
  window.opener = null;

  if (!params || isEmpty(params)) {
    window.open(url, '_blank');
    return;
  }

  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    queryParams.append(key, value.toString());
  });

  const fullUrl = `${url}?${queryParams.toString()}`;
  window.open(fullUrl, '_blank');
};
